module.exports = __webpack_public_path__ + "static/media/IconTemplates_-85.5e9c8d25.svg";